import { DocumentActionTypes } from './document.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    addDocumentSuccess: null,
    addDocumentError: null,
    addDocumentReqStatus: '',
    documentListSuccess: null,
    documentListError: null,
    documentDetailSuccess: null,
    documentDetailError: null
}

const documentReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DocumentActionTypes.ADD_DOCUMENT_REQUEST_SUCCESS:
            return {
                ...state,
                addDocumentSuccess: action.payload,
                addDocumentError: null,
                addDocumentReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case DocumentActionTypes.ADD_DOCUMENT_REQUEST_ERROR:
            return {
                ...state,
                addDocumentSuccess: null,
                addDocumentError: action.payload,
                addDocumentReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case DocumentActionTypes.ADD_DOCUMENT_REQUEST_STATUS:
            return {
                ...state,
                addDocumentReqStatus: ''
            }
        case DocumentActionTypes.DOCUMENT_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                documentListSuccess: action.payload,
                documentListError: null
            }
        case DocumentActionTypes.DOCUMENT_LIST_REQUEST_ERROR:
            return {
                ...state,
                documentListSuccess: null,
                documentListError: action.payload
            }
        case DocumentActionTypes.DOCUMENT_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                documentDetailSuccess: action.payload,
                documentDetailError: null
            }
        case DocumentActionTypes.DOCUMENT_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                documentDetailSuccess: null,
                documentDetailError: action.payload
            }
        case DocumentActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default documentReducer